import { useAppSelector } from '../../../../../../../../app/hooks'
import { RentIndexState } from '../../../../../../../../@types/state-types'
import { InitState } from '../../../../../../../../redux/reducers/root/initialState'

export type PriceBenchmarkSource = 'askingRent' | 'rentIndex'

type PriceBenchmarkData = {
  benchmarkSource: PriceBenchmarkSource
  benchmarkMinValue?: number
  benchmarkMaxValue?: number
  benchmarkRecommendedValue?: number
}

export const hasRentIndexBenchmarkData = (rentIndexResult: RentIndexState) =>
  rentIndexResult.status === 'available' &&
  rentIndexResult.minValue !== undefined &&
  rentIndexResult.averageValue !== undefined &&
  rentIndexResult.maxValue !== undefined

export function usePriceBenchmarkData(): PriceBenchmarkData {
  const { minValue, maxValue, recommendedValue } = useAppSelector((state: InitState) => state.valuationFeature)
  const rentIndexResult = useAppSelector((state: InitState) => state.rentIndexFeature)

  if (hasRentIndexBenchmarkData(rentIndexResult)) {
    return {
      benchmarkSource: 'rentIndex',
      benchmarkMinValue: rentIndexResult.minValue,
      benchmarkMaxValue: rentIndexResult.maxValue,
      benchmarkRecommendedValue: rentIndexResult.averageValue,
    }
  }

  return {
    benchmarkSource: 'askingRent',
    benchmarkMinValue: minValue,
    benchmarkMaxValue: maxValue,
    benchmarkRecommendedValue: recommendedValue,
  }
}
